var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoverGradient",class:_vm.direction},[(_vm.cover)?_c('Cover',{attrs:{"caption":true,"appear":_vm.appear,"cover":_vm.cover}}):_vm._e(),_c('div',{staticClass:"CoverGradient__gradient"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }